import React from 'react';
import FaqContent from 'containers/FaqContent';
import PageDialogOverlay from 'components/PageDialogOverlay';

function FaqPage() {
  return (
    <PageDialogOverlay
      parentClassName="faqs"
      headerTitle="FAQs"
      pageTitle="FAQ"
      backButtonText="Support"
      backLocation="/support"
    >
      <FaqContent />
    </PageDialogOverlay>
  );
}

export default FaqPage;
